const nlJSON = {
  Open: 'Open',
  Close: 'Afsluiten',
  'Go to next page': 'Naar volgende pagina',
  'Go to previous page': 'Naar vorige pagina',
  'Rows per page': 'Rijen per pagina',
  of: 'van',
  OR: 'of',
  'Something went wrong': 'Er ging iets fout',
  "The page you were looking for doesn't exist.":
    'De pagina die je zoekt, bestaat niet',
  "It's on us, we moved the content to a different page. The search below should help!":
    'De pagina is verplaatst, probeer misschien de zoek functionaliteit',
  Search: 'Zoeken',
  'Search terms here...': 'Zoektermen...',
  'Go to homepage': 'Ga naar de thuispagina',
  'You do not have permission to access this page':
    'Je hebt geen toegang tot deze pagina',
  'Please contact the Compair administrator to give you the appropriate permissions or sign in again with the correct account.':
    'Contacteer de Compair administrator om jou toegang te geven of log opnieuw in met een andere account',
  'Return to homepage': 'Terug naar de thuispagina',
  Unauthorized: 'Toegang verboden',
  'Together we can achieve clean air for all':
    'Samen kunnen we werken aan zuivere lucht voor iedereen',
  'Join COMPAIR and participate in measuring and reviewing air quality against other city data sources.':
    'Word lid van COMPAIR en neem deel aan het meten en toetsen van de luchtkwaliteit aan andere gegevensbronnen van de stad.',
  'Learn more': 'Ontdek meer',
  'What We Offer': 'Wat we aanbieden',
  'Easy to understand Interactive Dashboards':
    'Simpele, interactieve dashboards',
  'A cool new way to visualise and explore potential (urban) solutions quickly and effectively':
    'Een coole nieuwe manier om snel en effectief potentiële (stedelijke) oplossingen te visualiseren en te verkennen',
  'Dynamic Exposure Visualisation Application':
    'Dynamic Exposure Visualisation Application',
  'Dynamic Exposure Visualisation':'Visualisatie van de Dynamische Blootstelling',
  'Dynamic Exposure Visualisation Dashboard': 'Dashboard van de Dynamische Blootstelling',
  'Learn how airborne pollutants, including fine dust, vary along routes taken by different modes of travel.': 'Leer hoe verontreinigende stoffen in de lucht, waaronder fijn stof, variëren langs routes genomen door verschillende vervoerswijzen.',
  'A better understanding of the local issues in order to be more collaborative and creative in coming up with solutions':
    'Een beter begrip van de lokale problemen om meer samen te werken en creatief te zijn in het bedenken van oplossingen.',
  'Try COMPAIR Tools': 'Probeer de COMPAIR tools',
  'Making Data More Accessible, click through our offerings and try them for free.':
    'Gegevens toegankelijker maken, klik door ons aanbod en probeer het gratis uit.',
  'DEVA Application': 'DEVA applicatie',
  'Understand and compare how environmental situations change under different actions':
    'Begrijpen en vergelijken hoe milieusituaties veranderen bij verschillende acties',
  'See how you can affect your carbon footprint through your daily activities and learn how you can reduce your carbon footprint':
    'Zie hoe u uw CO2-voetafdruk kunt beïnvloeden door uw dagelijkse activiteiten en leer hoe u uw CO2-voetafdruk kunt verminderen.',
  'Explore your surroundings via your smartphone or tablet camera, so you can see a visual overlay of environmental information':
    'Ontdek je omgeving via de camera van je smartphone of tablet, met een extra laag omgevingsinformatie.',
  'Lets Be More Aware of Individual Actions and Behaviours':
    'Meer bewust worden van individuele acties en gedragingen',
  'Use our dashboards and learn what needs to be done at a personal, local and city-wide level to improve air quality':
    'Gebruik onze dashboards en ontdek wat er op persoonlijk, lokaal en stadsniveau kan gebeuren om de luchtkwaliteit te verbeteren.',
  'Explore results via an easy app and generate ideas for change':
    'Onderzoek de resultaten via een eenvoudige app en genereer ideeën voor verandering',
  'Raise awareness about local issues in your community and take part in our experiments':
    'Word bewust van lokale problemen in uw gemeenschap en neem deel aan onze experimenten',
  'Theme Settings': 'Thema instellingen',
  'Light mode': 'Lichte modus',
  'Pure Light': 'Zuiver licht',
  'Dark mode': 'Donkere modus',
  'Dark Spaces': 'Dark spaces',
  'Compair Dashboard': 'Compair Dashboard',
  Admin: 'Admin',
  User: 'Gebruiker',
  Guest: 'Gast',
  General: 'Algemeen',
  Home: 'Home',
  Dashboards: 'Dashboards',
  'Policy Monitoring': 'Impact van beleid opvolgen',
  'Browse the map': 'Onderzoek via de kaart',
  'Carbon Footprint': 'CO2-voetafdruk',
  Management: 'Administratie',
  'User Management': 'Administratie van gebruikers',
  'All aspects related to the app users can be managed from this page':
    'Alle aspecten met betrekking tot de gebruikers van de app kunnen vanaf deze pagina worden beheerd',
  'Create user': 'Nieuwe gebruiker aanmaken',
  'Add new user': 'Nieuwe gebruiker toevoegen',
  'Fill in the fields below to create and add a new user to the site':
    'Vul de onderstaande velden in om een nieuwe gebruiker aan te maken en toe te voegen aan de site',
  'First name': 'Voornaam',
  'The first name field is required': 'Voornaam is verplicht',
  'Last name': 'Familienaam',
  'The last name field is required': 'Familienaam is verplicht',
  'Email address': 'E-mail adres',
  'The email field is required': 'E-mail adres is verplicht',
  'The email provided should be a valid email address':
    'E-mail adres kan niet worden gevalideerd',
  Password: 'Wachtwoord',
  'The password field is required': 'Wachtwoord is verplicht',
  'Must be at least 8 characters':
    'Wachtwoord moet minstens 8 karakters lang zijn',
  Administrator: 'Administrator',
  Cancel: 'Cancel',
  'All users': 'Alle gebruikers',
  Administrators: 'Administrators',
  Users: 'gebruikers',
  'Search by name, email or username...':
    'Zoeken op naam, e-mail, gebruikersnaam,...',
  Name: 'Naam',
  Email: 'E-mail',
  Role: 'Rol',
  'Bulk actions': 'Bulk acties',
  Delete: 'Verwijder',
  'Are you sure you want to permanently delete this user account':
    'Weet u zeker dat u deze gebruikersaccount definitief wilt verwijderen?',
  'The user account has been removed': 'Het gebruikersaccount is verwijderd',
  'The user account was created successfully':
    'Het gebruikersaccount is succesvol aangemaakt',
  "We couldn't find any users matching your search criteria":
    'We konden geen gebruikers vinden die aan uw zoekcriteria voldoen',
  Edit: 'Pas aan',
  'Update user': 'Gebruiker bijwerken',
  'My Profile': 'Mijn profiel',
  'Manage informations related to your profile settings':
    'Beheer informatie over uw profielinstellingen',
  'Personal Details': 'Persoonlijke gegevens',
  'Manage informations related to your personal details':
    'Beheer informatie over uw persoonlijke gegevens',
  'Update profile': 'Profiel bijwerken',
  'Your profile was updated successfully':
    'Uw profiel werd met succes bijgewerkt',
  Security: 'Beveiliging',
  'Change your security preferences below':
    'Wijzig uw beveiligingsvoorkeuren hieronder',
  'Change Password': 'Wachtwoord wijzigen',
  'You can change your password here': 'U kunt uw wachtwoord hier wijzigen',
  'Change password': 'Wachtwoord wijzigen',
  'Fill in the fields below to change your password':
    'Vul onderstaande velden in om uw wachtwoord te wijzigen',
  'Current password': 'Huidig wachtwoord',
  'New password': 'Nieuw wachtwoord',
  'New password is required': 'Nieuw wachtwoord is verplicht',
  'Confirm new password': 'Nieuw wachtwoord bevestigen',
  'Confirm password is required': 'Wachtwoord bevestigen is vereist',
  'Current password is required': 'Huidig wachtwoord is vereist',
  'New password must be at least 8 characters':
    'Nieuw wachtwoord moet minstens 8 tekens bevatten',
  'Passwords do not match': 'Wachtwoorden komen niet overeen',
  'Update password': 'Wachtwoord bijwerken',
  'My profile': 'Mijn profiel',
  'Log in to view your details': 'Log in om uw gegevens te bekijken',
  'Language Switcher': 'Pas taal aan',
  'Sign out': 'Uitloggen',
  'Sign in': 'Aanmelden',
  'Fill in the fields below to sign into your account.':
    'Vul de onderstaande velden in om u aan te melden bij uw account.',
  'Lost password?': 'Wachtwoord verloren?',
  'Username or password is incorrect':
    'Gebruikersnaam of wachtwoord is onjuist',
  'Don’t have an account, yet?': 'Heeft u nog geen account?',
  'Sign up here': 'Registreer hier',
  'Recover Password': 'Herstel wachtwoord',
  'Enter the email used for registration to reset your password.':
    'Voer het e-mailadres in dat gebruikt is bij de registratie om uw wachtwoord opnieuw in te stellen.',
  'Send me a new password': 'Stuur me een nieuw wachtwoord',
  'Want to try to sign in again?': 'Wil je opnieuw proberen in te loggen?',
  'Click here': 'Klik hier',
  'Create account': 'Account aanmaken',
  'Fill in the fields below to sign up for an account.':
    'Vul de onderstaande velden in om een account aan te maken.',
  'Password must be at least 8 characters':
    'Wachtwoord moet minstens 8 tekens bevatten',
  'Both password need to be the same':
    'Beide wachtwoorden moeten hetzelfde zijn',
  'You must agree to our terms and conditions':
    'U moet akkoord gaan met onze algemene voorwaarden',
  'Create your account': 'Maak uw account aan',
  'Already have an account?': 'Heeft u al een account?',
  'Sign in here': 'Log hier in',
  'You have successfully signed up to Compair. Sign in below to continue':
    'U bent succesvol aangemeld bij Compair. Log hieronder in om verder te gaan',
  'Confirm password': 'Bevestig wachtwoord',
  'I accept the': 'Ik accepteer de',
  'terms and conditions': 'algemene voorwaarden',
  'by COMPAIR Project': 'door het COMPAIR-project',
  "This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No 101036563. This website represents the views of the COMPAIR project only.":
    'Dit project is gefinancierd door het onderzoeks- en innovatieprogramma Horizon 2020 van de Europese Unie onder subsidieovereenkomst nr. 101036563. Deze website vertegenwoordigt uitsluitend de standpunten van het COMPAIR-project.',
  'Terms & Conditions': 'Algemene voorwaarden',
  'Privacy Policy': 'Privacybeleid',
  // Admin interface (projects)
  'Create project': 'Project aanmaken',
};

export default nlJSON;
